export default __webpack_public_path__ + "static/media/juresta-login-part-left.6b989c29.svg";